<template>
  <div class="header">
    <div class="title">Arrabona Racing Team - Telemetry</div>
    <nav class="nav">
      <router-link class="nav-item" to="/dashboard"><v-icon scale="1.5" name="fa-home"/></router-link>
      <router-link class="nav-item" to="/track"><v-icon scale="1.5" name="co-pivotaltracker"/></router-link>
      <router-link class="nav-item" to="/diagram"><v-icon scale="1.5" name="bi-bar-chart-fill"/></router-link>
      <router-link class="nav-item" to="/battery"><v-icon scale="1.5" name="fa-car-battery"/></router-link>
    </nav>
    <img src="/img/ART_white_empty.png" class="logo" />
  </div>
</template>

<script setup>
</script>